/** Canonical decimal strings are the wire representation, never Numbers. */
export function validateDecimalInteger(value, maxDigits) {
  if (!Number.isSafeInteger(maxDigits) || maxDigits < 1) throw new TypeError('Invalid decimal digit limit');
  if (typeof value !== 'string' || !value.length || value.length > maxDigits || /[^0-9]/.test(value)
    || value.length > 1 && value[0] === '0')
    throw new TypeError('Invalid decimal integer');
  return value;
}

function decimal(value) {
  // The caller's database/metric boundary supplies its own range limit.
  if (typeof value !== 'string') throw new TypeError('Invalid decimal integer');
  return validateDecimalInteger(value, Math.max(1, value.length));
}

export function formatDecimalInteger(value, locale) {
  return BigInt(decimal(value)).toLocaleString(locale);
}

export function compareDecimalIntegers(a, b) {
  const left = BigInt(decimal(a)), right = BigInt(decimal(b));
  return left < right ? -1 : left > right ? 1 : 0;
}
